import { GET_CABRIDE_FAILED, GET_CABRIDE_REQUESTED, GET_CABRIDE_SUCCESS, GET_DAILYCUSTOMER_FAILED, GET_DAILYCUSTOMER_REQUESTED, GET_DAILYCUSTOMER_SUCCESS, GET_DASHBOARDFEEDBACK_FAILED, GET_DASHBOARDFEEDBACK_REQUESTED, GET_DASHBOARDFEEDBACK_SUCCESS, GET_OURCAR_FAILED, GET_OURCAR_REQUESTED, GET_OURCAR_SUCCESS, GET_RIDEACCEPT_FAILED, GET_RIDEACCEPT_REQUESTED, GET_RIDEACCEPT_SUCCESS, GET_RIDEANALYTIC_FAILED, GET_RIDEANALYTIC_REQUESTED, GET_RIDEANALYTIC_SUCCESS, GET_RIDE_FAILED, GET_RIDE_REQUESTED, GET_RIDE_SUCCESS, GET_TOPDRIVER_FAILED, GET_TOPDRIVER_REQUESTED, GET_TOPDRIVER_SUCCESS, GET_TOPSUBVENDOR_FAILED, GET_TOPSUBVENDOR_REQUESTED, GET_TOPSUBVENDOR_SUCCESS, GET_TOPVENDOR_FAILED, GET_TOPVENDOR_REQUESTED, GET_TOPVENDOR_SUCCESS, GET_TOTALREGISTRATION_FAILED, GET_TOTALREGISTRATION_REQUESTED, GET_TOTALREGISTRATION_SUCCESS } from "resources/actionTypes";

const initialState = {
  userOurCar: [],
  loading: false,
  error: null,
};
const initialStateCabRide = {
  userCabRide: [],
  loading: false,
  error: null,
};
const initialStateTopVendor = {
  userTopVendor: [],
  loading: false,
  error: null,
};
const initialStateTopSubVendor = {
  userTopSubVendor: [],
  loading: false,
  error: null,
};
const initialStateTopDriver = {
  userTopDriver: [],
  loading: false,
  error: null,
};
const initialStateRideAccept = {
  userRideAccept: [],
  loading: false,
  error: null,
};
const initialStateDashboardFeedback = {
  userDashboardFeedback: [],
  loading: false,
  error: null,
};
export function userOurCar(state =
  initialState, action) {
  switch (action.type) {
    case GET_OURCAR_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_OURCAR_SUCCESS:
      return {
        ...state,
        loading: false,
        userOurCar: action.userOurCar
      };
    case GET_OURCAR_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userCabRide(state =
  initialStateCabRide, action) {
  switch (action.type) {
    case GET_CABRIDE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_CABRIDE_SUCCESS:
      return {
        ...state,
        loading: false,
        userCabRide: action.userCabRide
      };
    case GET_CABRIDE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userTopVendor(state =
  initialStateTopVendor, action) {
  switch (action.type) {
    case GET_TOPVENDOR_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_TOPVENDOR_SUCCESS:
      return {
        ...state,
        loading: false,
        userTopVendor: action.userTopVendor
      };
    case GET_TOPVENDOR_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userTopSubVendor(state =
  initialStateTopSubVendor, action) {
  switch (action.type) {
    case GET_TOPSUBVENDOR_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_TOPSUBVENDOR_SUCCESS:
      return {
        ...state,
        loading: false,
        userTopSubVendor: action.userTopSubVendor
      };
    case GET_TOPSUBVENDOR_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userTopDriver(state =
  initialStateTopDriver, action) {
  switch (action.type) {
    case GET_TOPDRIVER_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_TOPDRIVER_SUCCESS:
      return {
        ...state,
        loading: false,
        userTopDriver: action.userTopDriver
      };
    case GET_TOPDRIVER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userRideAccept(state =
  initialStateRideAccept, action) {
  switch (action.type) {
    case GET_RIDEACCEPT_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_RIDEACCEPT_SUCCESS:
      return {
        ...state,
        loading: false,
        userRideAccept: action.userRideAccept
      };
    case GET_RIDEACCEPT_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userDashboardFeedback(state =
  initialStateDashboardFeedback, action) {
  switch (action.type) {
    case GET_DASHBOARDFEEDBACK_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_DASHBOARDFEEDBACK_SUCCESS:
      return {
        ...state,
        loading: false,
        userDashboardFeedback: action.userDashboardFeedback
      };
    case GET_DASHBOARDFEEDBACK_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}



